(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-custom-megamenu"] && !Shopify.designMode) return;
  try {
    class CustomMegaMenu {
    constructor() {
      this.triggers = document.querySelectorAll('.custom-megamenu-main-link');
      this.items = document.querySelectorAll('.custom-megamenu-item');
      this.init();
    }

    init() {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => this.toggle(e));
        trigger.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
      });

      // Listen on the FULL item container (trigger + dropdown panel)
      // so leaving from anywhere inside closes the menu
      this.items.forEach((item) => {
        item.addEventListener('mouseleave', (e) => this.handleItemMouseLeave(e));
      });

      document.addEventListener('click', (e) => this.handleClickOutside(e));

      // Mark link-only nav items active if current URL matches
      this.setActiveLinks();
    }

    setActiveLinks() {
      const currentPath = window.location.pathname;
      document.querySelectorAll('.custom-megamenu-link, .custom-megamenu-main-link').forEach((link) => {
        try {
          const linkPath = new URL(link.href).pathname;
          if (linkPath && currentPath.startsWith(linkPath)) {
            link.classList.add('is-active');
          }
        } catch (_) {}
      });
    }

    toggle(e) {
      const trigger = e.currentTarget;
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (trigger.tagName.toLowerCase() !== 'a' || !isExpanded) {
        e.preventDefault();
      }

      this.closeAll();
      if (!isExpanded) {
        this.open(trigger);
      }
    }

    open(trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      const item = trigger.closest('.custom-megamenu-item');
      if (item) {
        item.classList.add('active');

        // Position triangle under the center of the hovered trigger
        const content = item.querySelector('.custom-megamenu-content');
        if (content) {
          const triggerRect = trigger.getBoundingClientRect();
          const contentRect = content.getBoundingClientRect();
          const triggerCenterX = triggerRect.left + triggerRect.width / 2;
          const triangleLeft = triggerCenterX - contentRect.left;
          content.style.setProperty('--triangle-left', triangleLeft + 'px');
        }
      }
    }

    close(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      const item = trigger.closest('.custom-megamenu-item');
      if (item) {
        item.classList.remove('active');
      }
    }

    closeAll() {
      this.triggers.forEach((trigger) => this.close(trigger));
    }

    handleMouseEnter(e) {
      // Instantly close any other open item, then open this one — eliminates hover debounce lag
      this.closeAll();
      this.open(e.currentTarget);
    }

    // Fires when cursor leaves the entire item container (trigger + dropdown panel)
    handleItemMouseLeave(e) {
      const item = e.currentTarget;
      const trigger = item.querySelector('.custom-megamenu-main-link, .custom-megamenu-link');
      setTimeout(() => {
        if (!item.matches(':hover') && trigger) {
          this.close(trigger);
        }
      }, 150);
    }

    handleClickOutside(e) {
      if (!e.target.closest('.custom-megamenu-wrapper')) {
        this.closeAll();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new CustomMegaMenu();
    });
  } else {
    new CustomMegaMenu();
  }
  } catch(e) { console.error(e); }
})();

})();
